<template>
  <div class="main">
    <webheader></webheader>
    <div class="information">
      <div style="height:130px"></div>
      <div class="first-title">
        联系我们
      </div>
      <div class="flex-top">
        <div class="flex-top"
             style="padding-top:20px; ">
          <div class="text-gradient">
            <div class="en-title">
              Contact Us
            </div>
          </div>
        </div>

      </div>
      <div class="map flex-top">
        <div id="map"
             ref="allmap"
             style="width:345px;height:360px;border-top-left-radius: 15px;border-bottom-left-radius: 15px;"></div>
        <div class="company flex-top flex-column">
          <div class="company-info address"
               style="border-top-right-radius: 15px;">
            <div class="address-name  flex-left">
              <img src="../assets/img/address.png"
                   alt=""> <span class="pl-8">公司地址</span></div>
            <div class="address-desc">{{addr}}</div>
          </div>
          <div class="company-info phone"
               style="background:rgba(0,49,46,1);">
            <div class="address-name flex-left">
              <img src="../assets/img/phone.png"
                   alt=""> <span class="pl-8">电话</span> </div>
            <div class="address-desc">{{tel}}</div>
          </div>
          <div class="company-info email"
               style="border-bottom-right-radius: 15px;">
            <div class="address-name flex-left">
              <img src="../assets/img/email.png"
                   alt=""> <span class="pl-8">邮箱</span> </div>
            <div class="address-desc">{{email}}</div>
          </div>
        </div>
      </div>
    </div>
    <tabfooter></tabfooter>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BaiduMap
} from '@/util/map.js'
import { getconfig } from '@/api/website'
import webheader from '@/components/webheader'
import tabfooter from '@/components/tabfooter'
export default {
  mounted () {
    this.initConfig()
  },

  components: { tabfooter, webheader },
  name: 'contact',
  data () {
    return {
      coordinate: '',
      addr: '',
      tel: '',
      email: ''
    }
  },
  methods: {
    initConfig () {
      getconfig().then(res => {
        if (res.code === 0) {
          let arr = res.data
          arr.map(item => {
            if (item.name === 'coordinate') { this.coordinate = item.value }
            if (item.name === 'tel') { this.tel = item.value }
            if (item.name === 'addr') { this.addr = item.value }
            if (item.name === 'email') { this.email = item.value }
          })
          this.initMap()
        }
      })
    },
    initMap () {
      this.$nextTick(function () { 
        BaiduMap.init().then(BMap => {
          // this.init()

          let arr = this.coordinate.split(',')
          let map = new BMap.Map(this.$refs.allmap) // 创建Map实例
          map.centerAndZoom(new BMap.Point(arr[0], arr[1]), 20) // 初始化地图,设置中心点坐标和地图级别
          map.addControl(new BMap.MapTypeControl({ // 添加地图类型控件
            mapTypes: [
              BMAP_NORMAL_MAP,
              BMAP_HYBRID_MAP
            ]
          }))
          map.setCurrentCity('长沙') // 设置地图显示的城市 此项是必须设置的
          map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        })
      })
    }
  }
}
</script>

<style scoped>
.pl-8{
  padding-left: 8px;
}
.address-name {
  height: 16px;
  line-height: 16px; 
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 16px;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
  color: rgba(255, 255, 255, 1);
}
.address-desc {
  margin-top: 16px;
  /* padding-left: 16px; */
  height: 16px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 16px;
  color: rgba(222, 222, 222, 1);
  opacity: 1;
}
.map {
  padding-top: 80px;
}
.company-info {
  padding: 36px 60px; 

  width: 345px;
  text-align: left;
  background: rgba(0, 42, 39, 1);
  opacity: 1;
}
.information {
  height: calc(100% - 145px);
  background: url("../assets/img/contact.png");
}
</style>



// WEBPACK FOOTER //
// src/view/contact.vue